import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck, Info } from "lucide-react";

export default function ForgotPasswordPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7] px-4">
      <div className="w-full max-w-md bg-white border border-[#EAE3D9] rounded-3xl p-8 shadow-sm">
        <Link
          to="/"
          data-testid="back-to-login-link"
          className="inline-flex items-center gap-2 text-sm text-[#2B593F] hover:underline mb-6"
        >
          <ArrowLeft size={14} /> Torna al login
        </Link>

        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 rounded-xl bg-[#C8553D] text-[#FDFBF7] flex items-center justify-center">
            <ShieldCheck size={20} strokeWidth={1.8} />
          </div>
          <h1 className="font-display text-2xl font-bold text-[#2D2A26]">Password dimenticata?</h1>
        </div>

        <p className="text-sm text-[#4A4742] leading-relaxed mb-6">
          Per motivi di sicurezza, il reset password viene gestito direttamente da un <strong>amministratore</strong>.
        </p>

        <div className="bg-[#F5F1EA] border border-[#EAE3D9] rounded-2xl p-5 space-y-4">
          <div className="flex items-start gap-3">
            <Info size={18} className="text-[#C8553D] flex-shrink-0 mt-0.5" />
            <div className="text-sm text-[#4A4742] leading-relaxed">
              <p className="font-semibold text-[#2D2A26] mb-2">Come procedere:</p>
              <ol className="list-decimal pl-4 space-y-1.5">
                <li>Contatta un admin del club (Bibliocronache o Patrogames)</li>
                <li>Comunica la tua <strong>email</strong> o il tuo <strong>username</strong></li>
                <li>L'admin ti invierà un <strong>link personale</strong> per reimpostare la password</li>
                <li>Il link è valido per <strong>1 ora</strong> ed è usabile una sola volta</li>
              </ol>
            </div>
          </div>
        </div>

        <p className="text-xs text-[#757169] mt-6 text-center">
          Hai dimenticato anche email/username? Contatta il tuo admin di riferimento.
        </p>
      </div>
    </div>
  );
}
